import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import Common from '../../services/common';

interface IProps {
  storage?: IDataStorage;
}
interface IState {
  storage?: IDataStorage;
}
class Index extends React.Component<IProps,IState> {
  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    return res;
  }

  render() {
    const marco : React.CSSProperties = {
      backgroundImage: 'url(/images/page404.jpg)',
      backgroundPositionX: '50%',
      backgroundPositionY: '50%',
      backgroundSize: 'cover',
      height: '330px'
    }

    return (
      <>
        <div className="jumbotron jumbotron-main d-flex align-content-center flex-wrap justify-content-center" style={marco}>
          <div className="area-title" style={{ color: 'white' }}>
            <h1>Página no encontrada</h1>
            <p className="lead">  ¿No encontraste lo que estabas buscando?</p>
          </div>
        </div>
        <div className="w-100 d-flex align-content-center flex-wrap justify-content-center">
          <button className="btn btn-primary" style={{ marginTop: '25px' }} onClick={() => Common.url.redirect('/')}>
            <span>Volver al Inicio</span>
          </button>
        </div>
      </>
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
